import React from "react";
import MetricCard from "./metric-card";
import {
  faBookMedical,
  faHospitalAlt,
  faMicroscope,
  faScroll,
  faUserMd,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { stats } from "../../js/stats";
// import AdrcMap from '../metrics/adrc-map';

export default function MetricsHero() {
  return (
    <>
      <div style={{ fontWeight: 400 }} className="uk-text-lead uk-padding uk-padding-remove-top">
        The National Alzheimer’s Coordinating Center (NACC) functions as the centralized data repository, and
        collaboration and communication hub for the National Institute of Aging’s (NIA’s) Alzheimer’s Disease Research
        Centers (ADRC) Program, which currently includes {stats.adrcCount} centers across the United States.
      </div>
      <div className="uk-text-lead uk-padding uk-padding-remove-top">
        NACC is home to one of the largest, oldest, and most powerful Alzheimer’s datasets, built in collaboration with
        more than 42 Alzheimer’s Disease Research Centers (ADRCs) throughout the US over the past 20+ years.
      </div>
      <div className="uk-text-lead uk-padding uk-padding-remove-top uk-padding-remove-bottom">
        We are on a mission to modernize data collection, integration, and sharing to advance Alzheimer’s research. All
        NACC data is{" "}
        <Link className="bolder" to="/requesting-data/data-request-process">
          freely available
        </Link>{" "}
        to researchers.
      </div>
      <div className="uk-h2">About NACC UDS Data:</div>
      <MetricCards />

      {/* Static Map */}
      <div className="uk-padding uk-remove-padding-top uk-remove-padding-bottom">
        <div className="uk-h5">
          NACC collects data from {stats.adrcCount + stats.exploratoryCount} active ADRCs across 24 states
        </div>
        <a
          href="https://www.nia.nih.gov/health/alzheimers-disease-research-centers"
          target="_blank"
          rel="noopener noreferrer"
          title="NIH ADRD finder"
        >
          {/* Map courtesy www.mapchart.net */}
          <StaticImage src={"../../images/metrics/nia-adrc-map.png"} alt="ADRC Map" />
        </a>
      </div>
      {/* <AdrcMap /> */}
    </>
  );
}

export function MetricCards() {
  return (
    <div className="uk-grid uk-grid-small uk-padding uk-grid-match uk-padding-remove-top uk-padding-remove-bottom">
      <MetricCard
        icon={faUsers}
        title={`${stats.participantCount} participants with data at NACC`}
        subtitle={`${stats.activeParticipantCount} active participants`}
        href={"/requesting-data/nacc-data"}
        background={"#4B76A7"}
      />

      <MetricCard
        icon={faUserMd}
        title={`${stats.clinicalCount} clinical assessments `}
        subtitle={"1 - 20 per participant (median = 3)"}
        href={"/requesting-data/data-summary/uds"}
        background={"#769CC6"}
      />

      <MetricCard
        icon={faMicroscope}
        title={`${stats.neuropathCount} neuropathology exams`}
        subtitle={"from 58% of deceased participants"}
        href={"/requesting-data/data-request-process"}
        background={"#7A92C9"}
      />

      <MetricCard
        icon={faScroll}
        title={`${stats.studyCount} published studies`}
        subtitle={"using NACC data"}
        href={"/nacc-productivity/publications"}
        background={"#4F6BAB"}
      />

      <MetricCard
        icon={faHospitalAlt}
        // title={`${stats.adrcCount} ADRCs and ${stats.exploratoryCount} Exploratory Center${stats.exploratoryCount > 1 ? "s" : ""}`}
        title={`${stats.adrcCount} ADRCs`}
        subtitle={"currently contributing data across 25 states"}
        href={"/nacc-collaborations/about-nacc"}
        background={"#4584A2"}
      />

      <MetricCard
        icon={faBookMedical}
        title={"Expanding participant enrollment"}
        subtitle={""}
        // href={'/nacc-collaborations/participant-diversity'}
        href={"/requesting-data/nacc-data"}
        background={"#72A9C3"}
      />
    </div>
  );
}
